import React, {useEffect} from "react";
import {Grid, Typography} from "@mui/material";
import useChallenge2Style from "../../styles/challengeUntold/challenge2";
import kozel_meeet from "../../assets/images/kozel_meet/meet_logo.png";
import clsx from "clsx";
import TeaserFrame2 from "../TeaserFrame2";
import theme from "../../styles/themes/default";
import untold_challenge_step_2 from "../../assets/images/untold/untold_challenge_step_2.png";
import {NavLink} from "react-router-dom";
import {paths} from "../../AppRouters";
import useActivity from "../../hooks/useActivity";

const Challenge2: React.FC = () => {
    const styles = useChallenge2Style();
    const {registerActivity} = useActivity();

    useEffect(() => {
        registerActivity({
            name: 'UNTOLD_CHALLENGE_2',
            payload: {},
            callback: () => {},
        })
    }, []);

    return (
        <Grid container className={styles.container}>
            <Grid item xs={12} lg={6} className={styles.item}>
                <img src={kozel_meeet} alt={'kozel_meeet'} className={styles.logo} style={{maxWidth: '400px'}}/>
            </Grid>
            <Grid item xs={12} lg={6} className={styles.item}>
                <Typography className={styles.motoText}>There’s always room for one more!</Typography>
            </Grid>
            <Grid item xs={12} lg={6} className={clsx(styles.item, styles.wrapperTeaserFrame)}>
                <TeaserFrame2
                    title={<Typography className={styles.teaserFrameTitle}>GOATIFUL!</Typography>}
                    backgroundBoxTitle={theme.colors.dark_chocolate}
                    titleMarginTop={'min(-5vh,-5vw)'}
                >
                    <Grid container className={styles.teaserContainer}>
                        <Grid item xs={12} className={styles.teaserItem}>
                            <Typography className={styles.accessText}>You accessed the 2nd CHALLENGE!</Typography>
                        </Grid>
                        <Grid item xs={12} className={styles.teaserItem}>
                            <img src={untold_challenge_step_2} alt={'untold_challenge_step_2'} className={styles.imgStep}
                                 style={{maxWidth: '240px'}}/>
                        </Grid>
                        <Grid item xs={12} className={styles.teaserItem}>
                            <Typography className={styles.teaserTitle}>SKIING ON GRASS</Typography>
                        </Grid>
                        <Grid item xs={12} className={styles.teaserItem} flexDirection={'column'}>
                            <Typography className={styles.teaserText}>
                                Demonstrate coordination and teamwork!
                            </Typography>
                            <Typography className={styles.teaserText}>
                                Compete against a team or have fun with friends and challenge each other. Each team chooses 4 members to participate in the skiing challenge.
                            </Typography>
                            <Typography className={styles.teaserText}>
                                Get on your skis from the START line and slide easily and skillfully across the grass to the FINISH line. Be careful not to step over the other team's designated space. Pushing each other is not allowed; only hugging, at the end of the race!
                            </Typography>
                            <Typography className={styles.teaserTextSuccess}><b>Good luck!</b></Typography>
                        </Grid>
                    </Grid>
                </TeaserFrame2>
            </Grid>
            <Grid item xs={12} lg={4}>
                <Typography className={styles.prizesText}>Solving the second challenge brings 50 points to your group on kozel.ro</Typography>
            </Grid>
            <Grid item xs={12} lg={4}>
                <Typography className={styles.recommendGroupText}>Make sure you have your group formed - go to the
                    &nbsp;<NavLink to={paths.myGroup}>My Group</NavLink> section and invite your friends to the Kozel Meeet community!</Typography>
            </Grid>
        </Grid>
    )
}

export default Challenge2;